export const defaultDateFormat = "yyyy-MM-dd";

export const monthAndYearFormat = "LL/yyyy";
